function NewQuery(searchTerm, currentPage, labelsPerPage) {
  return {
    "query": {
      "function_score": {
        "query": {
          "bool": {
            "should": [
              {
                "match": {
                  "label.ngram": {
                    "query": searchTerm,
                    "boost": 10,
                    "_name": "ngram search * score_multiply_10"
                  }
                }
              },
              {
                "match": {
                  "label.strip_whitespace": {
                    "query": searchTerm,
                    "boost": 10,
                    "_name": "exact match * score_multiply_10"
                  }
                }
              },
              {
                "bool": {
                  "must": [
                    {
                    "multi_match": {
                      "query": searchTerm,
                      "fields": [
                        "label.transform1",
                        "label.transform2"
                      ]
                    }
                   }
                ],
                "boost": 2,
                "_name": "transform exact match * score_multiply_2"
                }
              },
              {
                "bool": {
                  "must": [
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.first_two_chars"
                        ]
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.third_char_transform1",
                          "label.third_char_transform2"
                        ]
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.last_3_chars"
                        ]
                      }
                    }
                  ],
                  "boost": 9,
                  "_name": "AR and transform(T) and HUR * score_multiply_9"
                }
              },
              {
                "bool": {
                  "must": [
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.first_two_chars"
                        ]
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.third_char_transform1",
                          "label.third_char_transform2"
                        ]
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.fourth_char_transform1",
                          "label.fourth_char_transform2"
                        ]
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.last_3_chars_plus_s",
                          "label.last_3_chars_double_last"
                        ]
                      }
                    }
                  ],
                  "boost": 9,
                  "_name": "AR and transform(T) and transform(H) and (URS or URR) *     score_multiply_9"
                }
              },
              {
                "bool": {
                  "must": [
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.first_two_chars"
                        ]
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.third_char_transform1",
                          "label.third_char_transform2"
                        ]
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.last_3_chars_plus_s"
                        ]
                      }
                    }
                  ],
                  "boost": 9,
                  "_name": "AR and transform(T) and URS * score_multiply_9"
                }
              },
              {
                "bool": {
                  "must": [
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.first_two_chars"
                        ]
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.last_3_chars"
                        ]
                      }
                    }
                  ],
                  "boost": 8,
                  "_name": "AR and HUR * score_multiply_8"
                }
              },
              {
                "bool": {
                  "must": [
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.first_two_chars"
                        ]
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.third_char_transform1",
                          "label.third_char_transform2"
                        ]
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.last_2_chars",
                          "label.last_2_chars_drop_last_keep_first_two"
                        ]
                      }
                    }
                  ],
                  "boost": 7,
                  "_name": "AR and transform(T) and UR * score_multiply_7"
                }
              },
              {
                "bool": {
                  "must": [
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.first_char_transform1_search_third_char",
                          "label.first_char_transform2_search_third_char"
                        ]
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.second_char_transform1_search_fourth_char",
                          "label.second_char_transform2_search_fourth_char"
                        ]
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.last_3_chars"
                        ]
                      }
                    }
                  ],
                  "boost": 7,
                  "_name": "**transform(A) and transform(R) and HUR * score_multiply_7"
                }
              },
              {
                "bool": {
                  "must": [
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.first_char_search_second_char"
                        ]
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.second_char_transform1_search_third_char",
                          "label.second_char_transform2_search_third_char"
                        ]
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.third_char_transform1_search_fourth_char",
                          "label.third_char_transform2_search_fourth_char"
                        ]
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.last_2_chars_drop_last_keep_first_two_for5chars"
                        ]
                      }
                    }
                  ],
                  "boost": 7,
                  "_name": "*A and transform(R) and transform(T) and UR? * score_multiply_7" 
                }
              },
              {
                "bool": {
                  "must": [
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.first_char_search_second_char"
                        ]
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.second_char_transform1_search_third_char",
                          "label.second_char_transform2_search_third_char"
                        ]
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.third_char_transform1_search_fourth_char",
                          "label.third_char_transform2_search_fourth_char"
                        ]
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.last_3_chars"
                        ]
                      }
                    }
                  ],
                  "boost": 7,
                  "_name": "*A and transform(R) and transform(T) and HUR * score_multiply_7"
                }
              },
              {
                "bool": {
                  "must": [
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.first_char_double"
                        ]
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.last_3_chars"
                        ]
                      }
                    }
                  ],
                  "boost": 6,
                  "_name": "AA and (HUR) * score_multiply_6"
                }
              },
              {
                "bool": {
                  "must": [
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.first_two_chars"
                        ]
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.last_3_chars_double_last"
                        ]
                      }
                    }
                  ],
                  "boost": 2,
                  "_name": "AR and URR * score_multiply_2"
                }
              },
              {
                "bool": {
                  "must": [
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.first_two_chars"
                        ]
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.last_3_chars_plus_s"
                        ]
                      }
                    }
                  ],
                  "boost": 2,
                  "_name": "AR and URS * score_multiply_2"
                }
              },
              {
                "bool": {
                  "must": [
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.first_two_chars"
                        ]
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.last_2_chars_drop_last_keep_first_two_for5chars"
                        ]
                      }
                    }
                  ],
                  "boost": 2,
                  "_name": "AR and HU? * score_multiply_2"
                }
              },
              {
                "bool": {
                  "must": [
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.first_char"
                        ]
                      }
                    },
                    {
                      "multi_match": {
                        "query": searchTerm,
                        "fields": [
                          "label.last_3_chars"
                        ]
                      }
                    }
                  ],
                  "boost": 2,
                  "_name": "A  and HUR * score_multiply_2"
                }
              }
            ],
            "filter": [
              {
                "term": {
                  "available": "true"
                }
              }
            ],
            "minimum_should_match": 1
          }
        },
        "functions": [
          {
            "filter": {
              "term": {
                "supplier_id": "19"
              }
            },
            "weight": 2
          }
        ],
        "score_mode": "multiply",
        "boost_mode": "multiply"
      }
    },
    "size": labelsPerPage,
    "from": (currentPage - 1) * labelsPerPage,
    "track_total_hits": true
  };
}

export default NewQuery;
